import { ProjectResource } from '../project/ProjectTypes.ts';
import { Technologies } from '../project/components/projectTechnologies/ProjectTechnologiesTypes.ts';
import { ProjectUrlsType } from '../project/components/projectUrls/ProjectUrlsTypes.ts';
    
/**
 * Technologies used in the Pathfinding Visualizer project.
 */
const TECHNOLOGIES: Technologies = [
    'React', 
    'SCSS', 
    'HTML5'
] as const;

/**
 * URLs for the Pathfinding Visualizer project.
 */
const PROJECT_URLS: ProjectUrlsType = {
    github: 'https://github.com/99061142/Pathfinding-Visualizer',
    live: 'https://99061142.github.io/Pathfinding-Visualizer/'
} as const;

const COMPLETION_YEAR: number = 2024;

export const pathfindingVisualizerResource: ProjectResource = {
    nl: {
        title: 'Pathfinding Visualizer',
        description: 'Een interactieve visualisatie tool voor padvindingsalgoritmes die laat zien hoe verschillende algoritmes werken in real-time met behulp van een visuele interface.',
        technologies: {
            title: 'Gebruikte technologieën',
            usedTechnologies: TECHNOLOGIES
        },
        features: {
            title: 'Kenmerken',
            items: [
                'Visualisatie van meerdere padvindingsalgoritmes',
                'Real-time animaties',
                'Aanpasbare snelheid',
                'Mogelijkheid tot gewichten en muren door grid generatie',
                'Mogelijkheid om specifieke start- en eindpunten in te stellen',
                'Mogelijkheid om specifieke cellen in te stellen als muren of gewichten'
            ]
        },
        urls: PROJECT_URLS,
        status: {
            status: 'Dit project is voltooid in',
            completionMonth: 'februari',
            completionYear: COMPLETION_YEAR,
            isFinished: true
        }
    },
    en: {
        title: 'Pathfinding Visualizer',
        description: 'An interactive visualization tool for pathfinding algorithms that demonstrates how different algorithms work in real-time with a visual interface.',
        technologies: {
            title: 'Used technologies',
            usedTechnologies: TECHNOLOGIES
        },
        features: {
            title: 'Features',
            items: [
                'Visualization of multiple pathfinding algorithms',
                'Real-time animations',
                'Adjustable speed',
                'Ability to add weights and walls through grid generation',
                'Ability to set specific start and end points',
                'Ability to designate specific cells as walls or weights'
            ]
        },
        urls: PROJECT_URLS,
        status: {
            status: 'This project was completed at',
            completionMonth: 'February',
            completionYear: COMPLETION_YEAR,
            isFinished: true
        }
    }
} as const;